/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../../../store/actions";
import { i18n } from '../../../../translate/i18n';
import {
	FormControl, Button, IconButton,
	FormControlLabel,
	Switch,
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { FilterList } from "@mui/icons-material";
import CloseIcon from '@mui/icons-material/Close';
import { DivFormTitle } from './styles';
import Autocomplete from '../../../../UI/Autocomplete/Autocomplete';
import moment from 'moment';

const ExpiredServicesFilterModal = (props) => {
	const dispatch = useDispatch();

	const [page] = useState(1);
	const [limit] = useState(30);
	const [orderBy] = useState("name");
	const [order] = useState("asc");

	const [startDate, setStartDate] = useState(null);
	const [endDate, setEndDate] = useState(null);

	const [searchTextEquipment, setSearchTextEquipment] = useState('');
	const [equipmentsFormated, setEquipmentsFormated] = useState([]);
	const [selectedEquipmentModels, setselectedEquipmentModels] = useState([]);

	const [searchTextPlace, setSearchTextPlace] = useState('');
	const [placesFormated, setPlacesFormated] = useState([]);
	const [selectedPlaces, setSelectedPlaces] = useState([]);

	const [searchTextArea, setSearchTextArea] = useState('');
	const [areasFormated, setAreasFormated] = useState([]);
	const [selectedAreas, setSelectedAreas] = useState([]);

	const [searchTextEquipmentGroup, setSearchTextEquipmentGroup] = useState('');
  const [equipmentsGroupsFormated, setEquipmentsGroupsFormated] = useState([]);
  const [selectedEquipmentGroups, setselectedEquipmentGroups] = useState([]);

	const [searchTextSite, setSearchTextSite] = useState('');
	const [sitesFormated, setSitesFormated] = useState([]);
	const [selectedSites, setSelectedSites] = useState([]);

	const [searchTextServiceType, setSearchTextServiceType] = useState('');
	const [serviceTypesFormated, setServiceTypesFormated] = useState([]);
	const [selectedServiceTypes, setSelectedServiceTypes] = useState([]);

	const [searchTextFrequency, setSearchTextFrequency] = useState('');
	const [frequenciesFormated, setFrequenciesFormated] = useState([]);
	const [selectedFrequencies, setSelectedFrequencies] = useState([]);

	const [searchTextCompanies, setSearchTextCompanies] = useState('');
	const [companiesFormated, setCompaniesFormated] = useState([]);
	const [selectedCompanies, setSelectedCompanies] = useState([]);

	const [showMandatoryServices, setShowMandatoryServices] = useState(false);
	const [showNonMandatoryServices, setShowNonMandatoryServices] = useState(false);

	const fetchPlaces = useCallback(
		() => dispatch(actions.fetchPlacesLeafs(selectedSites)),
		[selectedSites]
	);

	const fetchAreas = useCallback(
		() => dispatch(actions.fetchAreas(page, limit, searchTextArea, order, orderBy)),
		[page, limit, searchTextArea, order, orderBy]
	);

	const fetchSites = useCallback(
		() => dispatch(actions.fetchSites(page, limit, searchTextSite, order, orderBy)),
		[page, limit, searchTextSite, order, orderBy]
	);

	const fetchEquipments = useCallback(
		() => dispatch(actions.fetchEquipmentModels(page, limit, searchTextEquipment, order, orderBy)),
		[page, limit, searchTextEquipment, order, orderBy]
	);

	const fetchEquipmentGroups = useCallback(
    () => dispatch(actions.fetchGroups(page, limit, searchTextEquipmentGroup, order, orderBy)),
    [searchTextEquipmentGroup],
  );

	const fetchServiceTypes = useCallback(
		() => dispatch(actions.fetchServiceTypes(page, limit, searchTextServiceType, order, orderBy)),
		[page, limit, searchTextServiceType, order, orderBy]
	);

	const fetchFrequencies = useCallback(
		() => dispatch(actions.fetchFrequency(page, limit, searchTextFrequency, order, orderBy)),
		[page, limit, searchTextFrequency, order, orderBy]
	);

	const fetchCompanies = useCallback(
		() => dispatch(actions.fetchCompanies(page, limit, searchTextCompanies, order, orderBy)),
		[page, limit, searchTextCompanies, order, orderBy]
	);

	const role = useSelector(state => state.auth.selectedAccess.role);
	const sites = useSelector(state => state.sites.sites);
	const places = useSelector(state => state.places.placesLeafs);
	const areas = useSelector(state => state.areas.areas);
	const equipments = useSelector(state => state.equipmentModels.equipmentModels);
	const equipmentGroups = useSelector(state => state.groups.groups);
	const serviceTypes = useSelector(state => state.serviceTypes.serviceTypes);
	const frequencies = useSelector(state => state.frequency.frequencies);
	const companies = useSelector(state => state.companies.companies);

	const filteredSites = useSelector(state => state.sites.selectedSitesPlaces);
	const filteredPlaces = useSelector(state => state.expiredServices.filteredPlaces);
	const filteredAreas = useSelector(state => state.expiredServices.filteredAreas);
	const filteredCompanies = useSelector(state => state.expiredServices.filteredCompanies);
	const filteredEquipments = useSelector(state => state.expiredServices.filteredEquipmentModels);
	const filteredEquipmentGroups = useSelector(state => state.expiredServices.filteredEquipmentGroups);
	const filteredServiceTypes = useSelector(state => state.expiredServices.filteredServiceTypes);
	const filteredFrequencies = useSelector(state => state.expiredServices.filteredFrequencies);
	const filteredStartDate = useSelector(state => state.expiredServices.after);
	const filteredEndDate = useSelector(state => state.expiredServices.before);
	const filterShowMandatoryServices = useSelector(state => state.expiredServices.filterShowMandatoryServices);
	const filterShowNonMandatoryServices = useSelector(state => state.expiredServices.filterShowNonMandatoryServices);

	const loadingSites = useSelector(state => state.sites.loading);
	const loadingEquipments = useSelector(state => state.equipmentModels.loading);
	const loadingEquipmentGroups = useSelector(state => state.groups.loading);
	const loadingPlaces = useSelector(state => state.places.loading);
	const loadingAreas = useSelector(state => state.areas.loading);
	const loadingCompanies = useSelector(state => state.companies.loading);
	const loadingServiceTypes = useSelector(state => state.serviceTypes.loading);
	const loadingFrequencies = useSelector(state => state.frequency.loading);

	useEffect(() => {
		handleInputChangeSites(filteredSites);
		handleInputChangePlaces(filteredPlaces);
		handleInputChangeAreas(filteredAreas);
		handleInputChangeCompanies(filteredCompanies);
		handleInputChangeEquipments(filteredEquipments);
		handleInputChangeEquipmentGroups(filteredEquipmentGroups);
		handleInputChangeServiceTypes(filteredServiceTypes);
		handleInputChangeFrequencies(filteredFrequencies);
		setStartDate(filteredStartDate ? filteredStartDate : null);
		setEndDate(filteredEndDate ? filteredEndDate : null);
		setShowMandatoryServices(filterShowMandatoryServices);
		setShowNonMandatoryServices(filterShowNonMandatoryServices);
	}, []);

	useEffect(() => {
		fetchPlaces(selectedSites);
	}, [selectedSites]);

	useEffect(() => {
		fetchAreas(limit, searchTextArea, order, orderBy);
	}, [searchTextArea]);

	useEffect(() => {
		if (role !== 'contractor') {
      fetchCompanies(limit, searchTextCompanies, order, orderBy);
    }
	}, [searchTextCompanies]);

	useEffect(() => {
		fetchSites(limit, searchTextSite, order, orderBy);
	}, [searchTextSite]);

	useEffect(() => {
		fetchEquipments(limit, searchTextEquipment, order, orderBy);
	}, [searchTextEquipment]);

	useEffect(() => {
    fetchEquipmentGroups(limit, searchTextEquipmentGroup, order, orderBy);
  }, [searchTextEquipmentGroup]);

	useEffect(() => {
		fetchServiceTypes(limit, searchTextServiceType, order, orderBy);
	}, [searchTextServiceType]);

	useEffect(() => {
		fetchFrequencies(limit, searchTextFrequency, order, orderBy);
	}, [searchTextFrequency]);

	useEffect(() => {
		const dataFromRedux = places
		let returnArray = []
		dataFromRedux.rows.map(dt => returnArray.push({ value: dt._id, label: dt.path }))
		setPlacesFormated(returnArray)
	}, [places])

	useEffect(() => {
		const dataFromRedux = areas
		let returnArray = []
		dataFromRedux.rows.map(dt => returnArray.push({ value: dt._id, label: dt.name }))
		setAreasFormated(returnArray)
	}, [areas])

	useEffect(() => {
		const dataFromRedux = sites
		let returnArray = []
		dataFromRedux.rows.map(dt => returnArray.push({ value: dt._id, label: dt.name, ...dt }))
		setSitesFormated(returnArray)
	}, [sites])

	useEffect(() => {
		const dataFromRedux = equipments
		let returnArray = []
		dataFromRedux.rows.map(dt => returnArray.push({ value: dt._id, label: dt.name }))
		setEquipmentsFormated(returnArray)
	}, [equipments])

	useEffect(() => {
    const dataFromRedux = equipmentGroups;
    const returnArray = [];
    dataFromRedux.rows.map(dt => returnArray.push({ value: dt._id, label: dt.name }));
    setEquipmentsGroupsFormated(returnArray);
  }, [equipmentGroups]);

	useEffect(() => {
		const dataFromRedux = serviceTypes
		let returnArray = []
		dataFromRedux.rows.map(dt => returnArray.push({ value: dt._id, label: dt.name }))
		setServiceTypesFormated(returnArray)
	}, [serviceTypes])

	useEffect(() => {
		const dataFromRedux = frequencies
		let returnArray = []
		dataFromRedux.rows.map(dt => returnArray.push({ value: dt._id, label: dt.name }))
		setFrequenciesFormated(returnArray)
	}, [frequencies])

	useEffect(() => {
		const dataFromRedux = companies
		let returnArray = []
		dataFromRedux.rows.map(dt => returnArray.push({ value: dt._id, label: dt.name }))
		setCompaniesFormated(returnArray)
	}, [companies])

	const handleInputChangeSelectorPlaces = (text) => {
		setSearchTextPlace(text);
	}

	const handleInputChangeSelectorAreas = (text) => {
		setSearchTextArea(text);
	}

	const handleInputChangeSelectorCompanies = (text) => {
		setSearchTextCompanies(text);
	}

	const handleInputChangeSelectorSites = (text) => {
		setSearchTextSite(text);
	}

	const handleInputChangeSelectorEquipments = (text) => {
		setSearchTextEquipment(text);
	}

	const handleInputChangeSelectorEquipmentGroup = (text) => {
    setSearchTextEquipmentGroup(text);
  };

	const handleInputChangeSelectorServiceTypes = (text) => {
		setSearchTextServiceType(text);
	}

	const handleInputChangeSelectorFrequencies = (text) => {
		setSearchTextFrequency(text);
	}

	const handleInputChangePlaces = selected => {
		setSelectedPlaces(selected);
	}

	const handleInputChangeAreas = selected => {
		setSelectedAreas(selected);
	}

	const handleInputChangeCompanies = selected => {
		setSelectedCompanies(selected);
	}

	const handleInputChangeEquipments = selected => {
		setselectedEquipmentModels(selected);
	}

	const handleInputChangeEquipmentGroups = (selected) => {
		setselectedEquipmentGroups(selected);
	};

	const handleInputChangeServiceTypes = selected => {
		setSelectedServiceTypes(selected);
	}

	const handleInputChangeFrequencies = selected => {
		setSelectedFrequencies(selected);
	}

	const handleInputChangeSites = selected => {
		if(selected) {
			const dataFromRedux = selected
			let returnArray = []
			dataFromRedux.map(dt => returnArray.push({ value: dt._id, label: dt.name, ...dt }))
			setSelectedSites(returnArray);
		} else {
			setSelectedSites([]);
		}
	}

	const handleClickFilter = () => {
		dispatch(actions.setSitePlaces(selectedSites));
		dispatch(actions.filterExpiredServicesPlaces(selectedPlaces));
		dispatch(actions.filterExpiredServicesAreas(selectedAreas));
		dispatch(actions.filterExpiredServicesEquipmentModels(selectedEquipmentModels));
		dispatch(actions.filterExpiredServicesEquipmentGroups(selectedEquipmentGroups));
		dispatch(actions.filterExpiredServiceTypes(selectedServiceTypes));
		dispatch(actions.filterExpiredServicesFrequencies(selectedFrequencies));
		dispatch(actions.filterExpiredServicesCompanies(selectedCompanies));
		dispatch(actions.filterExpiredServiceStartDate(moment(startDate).toISOString()));
		dispatch(actions.filterExpiredServiceEndDate(endDate));
		dispatch(actions.expiredServicesSetShowMandatoryServicesFilter(showMandatoryServices));
		dispatch(actions.expiredServicesSetShowNonMandatoryServicesFilter(showNonMandatoryServices));
		props.closeModal();
	}

	const handleClickClearFilters = () => {
		setSelectedPlaces([])
		setSelectedAreas([])
		setSelectedCompanies([])
		setselectedEquipmentModels([])
		setselectedEquipmentGroups([])
		setSelectedServiceTypes([])
		setSelectedFrequencies([])
		setStartDate(null)
		setEndDate(null)
		setShowMandatoryServices(false);
		setShowNonMandatoryServices(false);
	}

	const verifyStartDateRange = () => {
		if(moment(endDate) < moment(startDate)) {
			setStartDate(endDate)
		}
	}

	return (
        <div style={styles.container}>
			<DivFormTitle style={styles.headerContainer}>
				<div style={{ display: 'flex', alignItems: 'center', fontSize: '1.25rem' }}>
					<FilterList style={{ marginRight: '1rem' }} />
					{i18n.t('filterListModalFilterExpiredServices.filter')}
					{((selectedPlaces && selectedPlaces.length > 0)
					|| (selectedEquipmentModels && selectedEquipmentModels.length > 0)
					|| (selectedEquipmentGroups && selectedEquipmentGroups.length > 0)
					|| (selectedAreas && selectedAreas.length > 0)
					|| (selectedSites && selectedSites.length > 0)
					|| (selectedCompanies && selectedCompanies.length > 0)
					|| (selectedServiceTypes && selectedServiceTypes.length > 0)
					|| (selectedFrequencies && selectedFrequencies.length > 0))
					&& <div style={styles.clearFilter} onClick={handleClickClearFilters}>{i18n.t('filterListModalFilterExpiredServices.clear')}</div>}
				</div>
				<IconButton onClick={props.closeModal} color='inherit' size="large">
					<CloseIcon />
				</IconButton>
			</DivFormTitle>
			<div style={styles.bodyContainer}>
				<FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						loading={loadingSites}
						label={i18n.t('autocompleteModalFilterExpiredServices.site')}
						data={sitesFormated}
						onSelectValue={handleInputChangeSites}
						valueSelected={selectedSites}
						newSearchText={handleInputChangeSelectorSites}
						isMulti
					/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<FormControlLabel
						control={<Switch checked={showMandatoryServices} onChange={e => setShowMandatoryServices(e.target.checked)} />}
						label={i18n.t('divModalFilterExpiredServices.mandatory')}
					/>
					<FormControlLabel
						control={<Switch checked={showNonMandatoryServices} onChange={e => setShowNonMandatoryServices(e.target.checked)} />}
						label={i18n.t('divModalFilterExpiredServices.nonMandatory')}
					/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin="normal">
          <Autocomplete
            loading={loadingEquipmentGroups}
            label={i18n.t('autocompleteModalFilterExpiredServices.equipmentGroups')}
            data={equipmentsGroupsFormated}
            onSelectValue={handleInputChangeEquipmentGroups}
            valueSelected={selectedEquipmentGroups}
            newSearchText={handleInputChangeSelectorEquipmentGroup}
            isMulti
          />
        </FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						loading={loadingEquipments}
						label={i18n.t('autocompleteModalFilterExpiredServices.equipments')}
						data={equipmentsFormated}
						onSelectValue={handleInputChangeEquipments}
						valueSelected={selectedEquipmentModels}
						newSearchText={handleInputChangeSelectorEquipments}
						isMulti
					/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						loading={loadingPlaces}
						label={i18n.t('autocompleteModalFilterExpiredServices.place')}
						data={placesFormated}
						onSelectValue={handleInputChangePlaces}
						valueSelected={selectedPlaces}
						newSearchText={handleInputChangeSelectorPlaces}
						isMulti
					/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						loading={loadingAreas}
						label={i18n.t('autocompleteModalFilterExpiredServices.area')}
						data={areasFormated}
						onSelectValue={handleInputChangeAreas}
						valueSelected={selectedAreas}
						newSearchText={handleInputChangeSelectorAreas}
						isMulti
					/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						loading={loadingCompanies}
						label={i18n.t('autocompleteModalFilterExpiredServices.companies')}
						data={companiesFormated}
						onSelectValue={handleInputChangeCompanies}
						valueSelected={selectedCompanies}
						newSearchText={handleInputChangeSelectorCompanies}
						isMulti
					/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						loading={loadingServiceTypes}
						label={i18n.t('autocompleteModalFilterExpiredServices.serviceTypes')}
						data={serviceTypesFormated}
						onSelectValue={handleInputChangeServiceTypes}
						valueSelected={selectedServiceTypes}
						newSearchText={handleInputChangeSelectorServiceTypes}
						isMulti
					/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						loading={loadingFrequencies}
						label={i18n.t('autocompleteModalFilterExpiredServices.frequencies')}
						data={frequenciesFormated}
						onSelectValue={handleInputChangeFrequencies}
						valueSelected={selectedFrequencies}
						newSearchText={handleInputChangeSelectorFrequencies}
						isMulti
					/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<DatePicker
						label={i18n.t('keyboardDatePickerModalFilterExpiredServices.from')}
						margin='normal'
						value={startDate && new Date(startDate)}
						onChange={date => setStartDate(date ?  date : null)}
						format="dd/MM/yyyy"
						maxDate={endDate ? new Date(endDate) : new Date().setDate(new Date().getDate()-1)}
						slotProps={{ textField: { variant: 'standard', } }}
					/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<DatePicker
						label={i18n.t('keyboardDatePickerModalFilterExpiredServices.to')}
						margin='normal'
						value={endDate && new Date(endDate)}
						onChange={date => setEndDate(date ?  date : null)}
						onBlurCapture={verifyStartDateRange}
						format="dd/MM/yyyy"
						maxDate={new Date().setDate(new Date().getDate()-1)}
						slotProps={{ textField: { variant: 'standard', } }}
					/>
				</FormControl>
			</div>
			<div style={styles.footerContainer}>
				<div
					onClick={props.closeModal}
					style={styles.buttonCancel}
				>
				{i18n.t('divModalFilterExpiredServices.cancel')}
				</div>
				<Button
					variant='contained'
					color='primary'
					onClick={handleClickFilter}
					style={styles.button}
				>
				{i18n.t('divModalFilterExpiredServices.ok')}
				</Button>
			</div>
		</div>
    );
}

const styles = {
	container: {
		width: '40rem',
		height: '100%'
	},
	headerContainer: {
		height: '5rem',
		padding: '0 1rem 0 2rem',
		backgroundColor: 'green',
		color: '#fff',
	},
	bodyContainer: {
		height: 'calc(100% - 10rem)',
		padding: '1rem 2rem',
		overflowY: 'auto',
		borderTop: '1px solid #ccc',
		borderBottom: '1px solid #ccc',
	},
	chip: {
		display: 'flex',
		alignItems: 'center',
		backgroundColor: '#C5D1E3',
		margin: '0.5rem 0',
		borderRadius: 10,
		padding: '0.3rem 1rem',
		justifyContent: 'space-between'
	},
	footerContainer: {
		height: '5rem',
		padding: '0 2rem',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
	button: {
		flex: 1,
		backgroundColor: 'green',
		borderRadius: '2rem',
		padding: '0.5rem 1.5rem',
		// width: '100%',
	},
	buttonCancel: {
		flex: 1,
		cursor: 'pointer',
		color: 'grey',
		alignItems: 'center',
		textAlign: 'center',
	},
	clearFilter: {
		fontSize: '1rem',
		marginLeft: '2rem',
		color: '#fff',
		cursor: 'pointer',
		textDecoration: 'underline'
	}
}


export default ExpiredServicesFilterModal;

